import { Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import * as FaIcons from "react-icons/fa";
import { CSVLink } from "react-csv";
import { useNavigate, useParams } from "react-router-dom";
import { Axios } from "../App";

const CSVExportPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [eventData, setEventData] = useState(null);
  const [csvData, setCsvData] = useState([]);
  const [csvDataHeader, setCsvDataHeader] = useState([]);

  const getEventData = async () => {
    return await Axios.post('events/getEventData.php', { id: id }).then(({data}) => {
      setEventData(data);
    });
  }
  const isEventExists = () => {
    return Axios.post("events/isEventExists.php", {
        "id": id,
    }).then(({data}) => {
      if (!data?.isExists) navigate('/event-manager');
    }).catch(e =>{
        console.error(e)
    })
  }

  const getAllParticipantsForExportByID = () => {
    Axios.post("participants/getAllParticipantsForExportByID.php", {
      id: id,
    })
      .then(({ data }) => {
        let array = [] as any;
        for (const [key, value] of Object.entries(data[0])) {
          if (key === 'is_participated') {
            array.push( { label: 'Résztvevő?', key: key })
            continue;
          }
          array.push( { label: value, key: key })
        }
        setCsvDataHeader(array)
        data.shift();
        setCsvData(data);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const getQueries = async () => {
    isEventExists();
    getEventData();
    getAllParticipantsForExportByID();
  };

  useEffect(() => {
    getQueries();
  }, [])

  return (
    <div style={{ padding: "10px" }}>
      <Typography variant="h4" mb="1rem">
        {/* @ts-ignore */}
        A(z) {eventData?.name} esemény csv Exportja
      </Typography>
      <Grid container>
        {/* @ts-ignore */}
        <CSVLink style={{textDecoration: 'none'}} data={csvData} headers={csvDataHeader} filename={`${eventData?.name} resztvevoi.csv`} separator={";"}>
          <Button variant="contained">
            <FaIcons.FaFileCsv />
            &nbsp; Letöltés
          </Button>
        </CSVLink>
      </Grid>
    </div>
  );
};

export default React.memo(CSVExportPage);
